// extracted by mini-css-extract-plugin
export var shake = "_c-1";
export var toastCloseButton = "_c-0";